<script setup lang="ts">
import { computed } from "vue";
import VModal from "@magnit/core/src/components/VModal/VModal.vue";
import VListItem from "@magnit/core/src/components/VListItem/VListItem.vue";
import VRadio from "@magnit/core/src/components/VRadio/VRadio.vue";
import VText from "@magnit/core/src/components/VText/VText.vue";
import type {
  ISortingValue,
  ISortingModalProps,
  ISortingConfigItem,
} from "@magnit/unit-catalog/src/unit-catalog.types";

const props = defineProps<ISortingModalProps>();
const emit = defineEmits<{
  "update:modelValue": [item: ISortingValue];
  close: [];
}>();
const getValueString = (item: ISortingValue) =>
  `sort=${item.value || ""}&order=${item.order || ""}`;
const sorting = computed(() => getValueString(props.modelValue));
const onChoose = (item: ISortingConfigItem) => {
  if (props.disabled || sorting.value === getValueString(item)) return;
  emit("update:modelValue", { value: item.value, order: item.order });
};
const onClose = (): void => {
  emit("close");
};
</script>

<template>
  <VModal
    id="unit-modal-sorting"
    wrapper-class="unit-modal-sorting"
    :closable="true"
    :open="open"
    :type="{ xs: 'bottom-sheet', m: 'modal' }"
    :active="open"
    title="Сортировка"
    @close="onClose"
  >
    <div class="sorting-modal-list">
      <label
        v-for="(item, index) in config"
        :key="index"
        :for="`smi-${item.value}-${item.order}`"
        class="sorting-modal-item"
        :class="{ 'sorting-modal-item_disabled': disabled }"
        @click="onChoose(item)"
      >
        <VListItem :divider="false" valign="center">
          <VText
            font="body-large-regular"
            :color="disabled ? 'tertiary' : 'primary'"
          >
            {{ item.title }}
          </VText>

          <template #right>
            <VRadio
              :id="`smi-${item.value}-${item.order}`"
              :model-value="sorting"
              :disabled="disabled"
              :value="getValueString(item)"
              wrapper-class="sorting-modal-item_radio"
            />
          </template>
        </VListItem>
      </label>
    </div>
  </VModal>
</template>

<style lang="postcss" scoped>
.sorting-modal-list {
  width: 380px;
  max-width: 100%;
}

.sorting-modal-item {
  cursor: pointer;

  &_disabled {
    cursor: not-allowed;
  }

  :deep(.sorting-modal-item_radio) {
    margin: auto;
  }
}
</style>
